import math from './expression';

const metaChar = /[-[\]{}()*+?.\\^$|,]/g;
const escapeRegEx = (str) => {
	return str.replace(metaChar, "\\$&");
};

// (c) 2007 Steven Levithan <stevenlevithan.com>
// MIT License

/*** matchRecursive
	accepts a string to search and a format (start and end tokens separated by "...").
	returns an array of matches, allowing nested instances of format.

	examples:
		matchRecursive("test",          "(...)")   -> []
		matchRecursive("(t(e)s)()t",    "(...)")   -> ["t(e)s", ""]
		matchRecursive("t<e>>st",       "<...>")   -> ["e"]
		matchRecursive("t<<e>st",       "<...>")   -> ["e"]
		matchRecursive("t<<e>>st",      "<...>")   -> ["<e>"]
		matchRecursive("<|t<e<|s|>t|>", "<|...|>") -> ["t<e<|s|>t"]
*/
const matchRecursive = function () {
	var	formatParts = /^([\S\s]+?)\.\.\.([\S\s]+)/;

	return function (str, format) {
		var p = formatParts.exec(format);
		if (!p) throw new Error("format must include start and end tokens separated by '...'");
		if (p[1] === p[2]) throw new Error("start and end format tokens cannot be identical");

		var	opener = p[1],
			closer = p[2],
			/* Use an optimized regex when opener and closer are one character each */
			iterator = new RegExp(format.length === 5 ? "["+escapeRegEx(opener+closer)+"]" : escapeRegEx(opener)+"|"+escapeRegEx(closer), "g"),
			results = [],
			openTokens, matchStartIndex, match;

		do {
			openTokens = 0;
			while ((match = iterator.exec(str))) {
				if (match[0] === opener) {
					if (!openTokens)
						matchStartIndex = iterator.lastIndex;
					openTokens++;
				} else if (openTokens) {
					openTokens--;
					if (!openTokens)
						results.push(str.slice(matchStartIndex, match.index));
				}
			}
		} while (openTokens && (iterator.lastIndex = matchStartIndex));

		return results;
	};
}();

let expandTreeExpressions = (items, values, parent = null) => {
	let t = {};

	for(let i of items) {
		let subitems = matchRecursive(i, "[...]");
		try {
			if (!subitems.length) {
				let candidate = String(math.evaluate(i, values));
				let reEval = matchRecursive(candidate, "[...]");
				if (!reEval.length) {
					if (parent) {
						t = candidate;
					} else {
						t[i] = candidate;
					}
				} else {
					t[i] = expandTreeExpressions(reEval, values, i);
				}
			} else {
				t[i] = expandTreeExpressions(subitems, values);
			}
		} catch (e) {
			t[i] = `[${i}]`;
			console.log(`Expression [${i}] not found`);
		}
			
	}

	return t;
}

let resolveTreeExpressions = (tree, expression, shuoldEval = false) => {
	let value = String(expression);

	for(let exp in tree) {
		if (typeof tree[exp] === 'string' ) {
			value = value.replace(new RegExp('\\['+escapeRegEx(exp)+'\\]','gi'), tree[exp]);
		} else {
			let resolve = resolveTreeExpressions(tree[exp], exp);
			value = value.replace(new RegExp('\\['+escapeRegEx(exp)+'\\]','gi'), resolve);
		}
	}

	return shuoldEval ? math.evaluate(value) : value;
}

let evaluateMathExpressions = (content) => {
	const funcsToFind = [
		/floor\(.*?\)/gi
	];

	let match = null;
	let prevent = 0;

	for(let func of funcsToFind) {
		while((match = func.exec(String(content))) && prevent++<1000){
			try {
				if (match && typeof match[0] !== 'undefined') {
					content = content.replace(match[0], math.evaluate(match[0]));
				} else {
					throw new Error('int statement misformatted');
				}
			} catch (e) {
				content = content.replace(match[0], "");
				console.log(`Unable to evaluate ${match[0]} statement`, match);
				console.error(e);
			}
		}
	}

	return content;
}



export {
	expandTreeExpressions,
	resolveTreeExpressions,
	matchRecursive,
	evaluateMathExpressions
}